import { Pipe, PipeTransform } from '@angular/core';
import { getApp } from '@angular/fire/app';
import { getDownloadURL, getMetadata, getStorage, ref } from '@angular/fire/storage';

@Pipe({
  name: 'storageUrl',
  standalone: true,
})
export class StorageUrlPipe implements PipeTransform {
  async transform(value: string, ...args: string[]): Promise<string> {
    const bucket = args?.length ? args[0] : undefined;
    const storage = getStorage(getApp(), bucket);
    const docRef = ref(storage, value);

    try {
      const metadata = await getMetadata(docRef);
      if (metadata) {
        return getDownloadURL(docRef);
      }

      return Promise.resolve('DOC_INVALID_URL');
    } catch (err) {
      console.error(err);
      // Document may not exists.
      return Promise.resolve('DOC_INVALID_URL');
    }
  }
}
